module.exports = __webpack_public_path__ + "img/NGC-300.d7cb9722.jpg";